module.exports = __webpack_public_path__ + "img/shopping-bag.90ac36de.svg";